import { ChevronRightIcon, HouseIcon } from "lucide-react";
import * as React from "react";

interface PathSegment {
  id: string;
  name: string;
}

interface FilesSelectTreeBreadcrumbProps {
  path: PathSegment[];
  onNavigate: (folderId: string | null) => void;
}

export const FilesSelectTreeBreadcrumb: React.FC<FilesSelectTreeBreadcrumbProps> = ({ path, onNavigate }) => (
  <nav aria-label="Folder path" className="flex min-w-0 flex-1 items-center overflow-hidden text-sm text-gray-600">
    <button
      onClick={() => onNavigate(null)}
      className="flex shrink-0 items-center gap-1 hover:text-blue-600 focus:outline-none"
      title="Root"
      style={{
        fontWeight: path.length === 0 ? "bold" : "normal",
      }}
    >
      <HouseIcon className="h-4 w-4" />

      <span>Home</span>
    </button>
    {path.map((segment, index) => (
      <React.Fragment key={segment.id}>
        <ChevronRightIcon className="mx-2 h-4 w-4 shrink-0 text-gray-400" />
        <button
          onClick={() => onNavigate(segment.id)}
          className="min-w-0 truncate hover:text-blue-600 focus:outline-none"
          disabled={index === path.length - 1}
          style={{
            cursor: index === path.length - 1 ? "default" : "pointer",
            fontWeight: index === path.length - 1 ? "bold" : "normal",
          }}
        >
          {segment.name}
        </button>
      </React.Fragment>
    ))}
  </nav>
);
